import { createContext, useContext, useState } from "react"
import { taskScheduledService } from "../services/taskScheduledService"
import { useUtiles } from "./utilesContext"
import { useNavigate } from "react-router"
import Swal from "sweetalert2"


export const ScheduledContext = createContext()

export const useScheduled = () => {
    return useContext(ScheduledContext)
}

export const ScheduledProvider = ({ children }) => {

    const { setAlertSnackbar, setLoadingApi, resetOpenSilder } = useUtiles()

    const navigate = useNavigate()


    const [stepActive, setStepActive] = useState(1)


    const [groupScheduled, setGroupScheduled] = useState({
        description: "",
        asset: null,
        hash_code: "",
        name: "",
    })

    const resetGroupScheduled = () => {
        setGroupScheduled({
            description: "",
            asset: null,
            hash_code: "",
            name: "",
        })
    }

    const [groupScheduledTasks, setGroupScheduledTasks] = useState([])


    const setSelectAsset = (asset) => {
        setGroupScheduled({...groupScheduled, asset: asset})
    }

    const getGroupScheduledByHash = async (hash) => {
        try {
            setLoadingApi(true)
            const response = await taskScheduledService.getGroupScheduledByHash(hash)
            setGroupScheduled({
                description: response.data.description,
                asset: response.data.asset,
                hash_code: response.data.hash_code,
                name: response.data.name
            })
            setGroupScheduledTasks(response.data.tasks)
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        } finally {
            setLoadingApi(false)
        }
    }

    const [tabActive, setTabActive] = useState(0)

    const createGroupScheduled = async () => {
        
        try {
            const data = {
                name: groupScheduled.name,
                description: groupScheduled.description,
                hash_code: groupScheduled.asset.hash_code,
                id: groupScheduled.asset.id,
                type_asset: groupScheduled.asset.type
            }
            const response = await taskScheduledService.createGroupScheduled(data)
            if (response.status === 201) {
                setGroupScheduled({...groupScheduled, hash_code: response.data.group_scheduled.hash_code})
                setAlertSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: 'success'
                })
                navigate('/task/scheduled/plan/' + response.data.group_scheduled.hash_code)
                setTabActive(1)
            }
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        }
    }

    const updateGroupScheduled = async () => {
        
        try {
            const confirm = await Swal.fire({
                title: '¿Está seguro de actualizar la programación?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
            if (!confirm.isConfirmed) return
            const data = {
                name: groupScheduled.name,
                description: groupScheduled.description,
                hash_code: groupScheduled.hash_code,
            }
            const response = await taskScheduledService.updateGroupScheduled(data)
            if (response.status === 200) {
                setAlertSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: 'success'
                })
            }
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        }
    }

    const deleteGroupScheduled = async (groupScheduledId) => {
        const confirm = await Swal.fire({
            title: '¿Está seguro de eliminar el grupo programado?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        if (!confirm.isConfirmed) return
        try {
            const response = await taskScheduledService.deleteGroupScheduled(groupScheduledId)
            if (response.status === 200) {
                setAlertSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: 'success'
                })
                getAllGroupScheduled()

            }
        }  catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        }
    }
    //Eliminar una tarea template


    const deleteTaskTemplate = async (taskScheduledId) => {
        const confirm = await Swal.fire({
            title: '¿Está seguro de eliminar la tarea template?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        try {
            if (!confirm.isConfirmed) return
            const response = await taskScheduledService.deleteTaskTemplate(taskScheduledId)
            if (response.status === 200) {
                setAlertSnackbar({
                    open: true,
                    message: "Tarea template eliminada correctamente",
                    severity: 'success'
                })
               
                getGroupScheduledByHash(groupScheduled.hash_code)
            }
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        }
    }





    
    const [groupScheduledAll, setGroupScheduledAll] = useState([])
    const [loadingGroupScheduledAll, setLoadingGroupScheduledAll] = useState(false)
    const getAllGroupScheduled = async (params) => {
        try {
            setLoadingGroupScheduledAll(true)
            const response = await taskScheduledService.getAllGroupScheduled(params)
            setGroupScheduledAll(response.data)
            console.log(response.data)
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        } finally {
            setLoadingGroupScheduledAll(false)
        }
    }


    /***
     * Crear TASKs 
     */

    const [taskScheduled, setTaskScheduled] = useState({
        description: "",
        note: "",
        typeTask: "",
        classification_1: "",
        classification_2: "",
        priority: "Media",
        time_duration: "000:10",
        group_scheduled_hash: "",
        required_ssoma_document: "NO",
        assigned_to_ot: false,
    })

    const resetTaskScheduled = () => {

        setTaskScheduled({
            description: "",
            note: "",
            typeTask: "",
            classification_1: "",
            classification_2: "",
            priority: "Media",
            time_duration: "000:10",
            group_scheduled_hash: "",
            required_ssoma_document: "NO",
            assigned_to_ot: false,
        })
    }

    const setSelectTypeTask = (typeTask) => {
        setTaskScheduled({...taskScheduled, typeTask: typeTask})
    }

    const setSelectClassification = (classification, number) => {
        setTaskScheduled({...taskScheduled, [number]: classification})
        console.log(classification)
    }

    const createTask = async () => {
        try {
            const data = {
                task_template: taskScheduled,
                task_asset: {
                    type_asset: groupScheduled.asset.type_asset,
                    id: groupScheduled.asset.id,
                    hash_code: groupScheduled.asset.hash_code,
                },
                subtasks: subtaskScheduledList,
              
            }

            data.task_template.group_scheduled_hash = groupScheduled.hash_code



            const response = await taskScheduledService.createTask(data)
            if (response.status === 201) {
                setAlertSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: 'success'
                })

                resetSubtaskScheduled()
                resetTaskScheduled()
                getGroupScheduledByHash(groupScheduled.hash_code)
                resetOpenSilder()
            }
        } catch (error) {
            console.log(error)
        }
    }
    const updateTask = async () => {
        try {
            const data = {
                task_template: taskScheduled,
                subtasks: subtaskScheduledList,
              
            }

            data.task_template.group_scheduled_hash = groupScheduled.hash_code
            data.hash_code = taskScheduled.hash_code

            console.log(data)
            const response = await taskScheduledService.updateTask(data)
            if (response.status === 200) {
                setAlertSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: 'success'
                })
            }
            resetTaskScheduled()
            resetSubtaskScheduled()
            getGroupScheduledByHash(groupScheduled.hash_code)

        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        }
    }

    const [indexSubtaskScheduled, setIndexSubtaskScheduled] = useState(null)
    const [subtaskScheduled, setSubtaskScheduled] = useState({
        code: "",
        order: 1,
        description: "",
        type_field: "",
        is_mandatory: false,
        options: [{
            value: "Opcion 1",
        }, {
            value: "Opcion 2",
        }, {
            value: "Opcion 3",
        }],
    })

   
    const [subtaskScheduledList, setSubtaskScheduledList] = useState([
        {
            order: 1,
            description: "Subtarea 1",
            type_field: "boolean",
            is_mandatory: true,
            options: [],
            code: "",
        }
    ])
    const [subtaskScheduledValue, setSubtaskScheduledValue] = useState({
        value: "",
    })
    const resetSubtaskScheduled = () => {
        setSubtaskScheduled({
            order: 1,
            description: "",
            type_field: "",
            is_mandatory: false,
            options: [{
                value: "Opcion 1",
            }, {
                value: "Opcion 2",
            }, {
                value: "Opcion 3",
            }],
            code: "",
        })
        setSubtaskScheduledValue({
            value: "",
        })
    }


    //PROGRAMAR LA TAREA TEMPLATE

    const [programTask, setProgramTask] = useState({
        task_scheduled: null,
        frequency: null,
        dates_programmed: [],
        group_scheduled_hash: "",
        programmer_dates_created: false,
    })

    const resetProgramTask = () => {
        setProgramTask({
            task_scheduled: null,
            frequency: null,
            dates_programmed: [],
            group_scheduled_hash: "",
            programmer_dates_created: false,
        })
    }
    //Programar la tarea template
    const scheduleTaskTemplate = async (data) => {

        const confirm = await Swal.fire({
            title: '¿Está seguro de programar la tarea template?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        console.log(data)
        try {
            if (!confirm.isConfirmed) return
           
            const response = await taskScheduledService.scheduleTaskTemplate(data)
            if (response.status === 201) {
                setAlertSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: 'success'
                })
                setProgramTask({...programTask, programmer_dates_created: true})
                getGroupScheduledByHash(groupScheduled.hash_code)
            }
           
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        }


    }

    //reprogramar la tarea template
    const reprogramTaskTemplate = async (data) => {

        const confirm = await Swal.fire({
            title: '¿Está seguro de reprogramar la tarea template?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        if (!confirm.isConfirmed) return
        try {
            if (!confirm.isConfirmed) return
            const response = await taskScheduledService.reprogramTaskTemplate(data)
            if (response.status === 200) {
                setAlertSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: 'success'
                })
                setProgramTask({...programTask, programmer_dates_created: true})
                getGroupScheduledByHash(groupScheduled.hash_code)
            }
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        }
    }

    const deleteProgramTask = async (taskScheduledId) => {
        const confirm = await Swal.fire({   
            title: '¿Está seguro de eliminar la tarea programada?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        if (!confirm.isConfirmed) return
        try {
        const response = await taskScheduledService.deleteProgramTask(taskScheduledId)
            if (response.status === 200) {
                setAlertSnackbar({
                    open: true,
                    message: response.data.message,
                    severity: 'success'
                })
                setProgramTask({...programTask, dates_programmed: [], programmer_dates_created: false})
                getGroupScheduledByHash(groupScheduled.hash_code)
            }
        } catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        }
    }

   









    return (
        <ScheduledContext.Provider value={{ stepActive, setStepActive, 
        groupScheduled, setGroupScheduled, 
        createGroupScheduled,
        setSelectAsset,
        tabActive,
        setTabActive,
        getGroupScheduledByHash,
        updateGroupScheduled,
        createTask,
        taskScheduled,
        setTaskScheduled,
        setSelectTypeTask,
        setSelectClassification,
        getAllGroupScheduled,
        groupScheduledAll,
        subtaskScheduled,
        setSubtaskScheduled,
        subtaskScheduledList,
        setSubtaskScheduledList,
        subtaskScheduledValue,
        setSubtaskScheduledValue,
        indexSubtaskScheduled,
        setIndexSubtaskScheduled,
        resetSubtaskScheduled,
        groupScheduledTasks,
        setGroupScheduledTasks,
        updateTask,
        resetTaskScheduled,
        resetGroupScheduled,
        deleteTaskTemplate,
        scheduleTaskTemplate,
        programTask,
        setProgramTask,
        resetProgramTask,
        reprogramTaskTemplate,
        deleteProgramTask,
        deleteGroupScheduled,
        loadingGroupScheduledAll,
    }}>
            {children}
        </ScheduledContext.Provider>
    )
}